import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Landmark, ShieldCheck, ArrowRight } from 'lucide-react';

export default function NewsEvents() {
  const { t } = useTranslation();

  const newsItems = [
    {
      id: 1,
      titleKey: 'news_inauguration_title',
      descKey: 'news_inauguration_desc',
      date: "18 Nov. 2020",
      source: "Secrétariat Général",
      icon: <Landmark className="w-6 h-6 opacity-60 group-hover:opacity-100 transition-opacity" />,
      tag: "Inauguration Ministérielle"
    },
    {
      id: 2,
      titleKey: 'news_beingcert_title',
      descKey: 'news_beingcert_desc',
      date: "Jan. 2024",
      source: "Relations Internationales",
      icon: <ShieldCheck className="w-6 h-6 opacity-60 group-hover:opacity-100 transition-opacity" />,
      tag: "Certification USA"
    }
  ];

  const events = [
    {
      id: 1,
      titleKey: 'event_admissions_open',
      descKey: 'event_admissions_open_desc',
      dateKey: 'admissions_calendar_open_date',
      location: "ESTAD Campus & En ligne"
    },
    {
      id: 2,
      titleKey: 'event_admissions_close',
      descKey: 'event_admissions_close_desc',
      dateKey: 'admissions_calendar_close_date',
      location: "23h59 GMT+1"
    },
    {
      id: 3,
      titleKey: 'event_academic_start',
      descKey: 'event_academic_start_desc',
      dateKey: 'admissions_calendar_start_date',
      location: "9h00 | Grand Hall"
    }
  ];

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-16">
        
        {/* News Column (2/3 width on desktop) */}
        <div className="lg:col-span-2 animate-in fade-in slide-in-from-left-8 duration-700">
          <h2 className="text-navy text-3xl font-black mb-12 uppercase tracking-tighter border-b-2 border-gray-100 pb-5">
            {t('section_news_title', 'Dans les actualités')}
          </h2>
          <div className="space-y-16">
            {newsItems.map((item) => (
              <div key={item.id} className="flex flex-col sm:flex-row gap-8 group">
                <div className="w-full sm:w-44 h-28 bg-navy flex-shrink-0 flex flex-col items-center justify-center text-white p-4 text-center transition-all duration-300 group-hover:shadow-xl group-hover:-translate-y-1 rounded-sm">
                  <div className="mb-2">{item.icon}</div>
                  <span className="text-[10px] font-black uppercase tracking-[0.2em] leading-tight">
                    {item.tag}
                  </span>
                </div>
                <div className="flex-1">
                  <Link to="/news" className="text-navy text-2xl font-black hover:underline hover:text-gold transition-colors block leading-tight mb-4">
                    {t(item.titleKey)}
                  </Link>
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed line-clamp-2">
                    {t(item.descKey)}
                  </p>
                  <p className="text-gray-400 text-[10px] font-black uppercase tracking-[0.2em]">
                    {item.date} | {item.source}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-16">
            <Link to="/news" className="inline-flex items-center gap-2 text-navy font-black underline hover:text-gold transition-all duration-300 uppercase tracking-widest text-sm">
              {t('news_view_all', "Voir tous les articles d'actualité")}
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        {/* Events Column (1/3 width on desktop) */}
        <div className="bg-gray-50 p-8 md:p-12 border-l border-gray-200 shadow-sm animate-in fade-in slide-in-from-right-8 duration-700">
          <h2 className="text-navy text-3xl font-black mb-12 uppercase tracking-tighter border-b-2 border-gray-300 pb-5">
            {t('section_events_title', 'Événements')}
          </h2>
          <div className="space-y-12">
            {events.map((event) => (
              <div key={event.id} className="group border-b border-gray-200 pb-8 last:border-0 last:pb-0">
                <Link to="/news" className="text-navy font-black hover:underline hover:text-gold transition-colors block mb-3 text-lg leading-tight">
                  {t(event.titleKey)}
                </Link>
                <p className="text-gray-600 text-sm leading-relaxed line-clamp-2">
                  {t(event.descKey)}
                </p>
                <div className="mt-6 flex flex-col">
                  <span className="text-navy text-sm font-black uppercase tracking-wider">
                    {t(event.dateKey)}
                  </span>
                  <span className="text-gray-500 text-[10px] font-bold uppercase tracking-widest mt-1">
                    {event.location}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-12">
            <Link to="/news" className="inline-flex items-center gap-2 text-navy font-black underline hover:text-gold transition-all duration-300 uppercase tracking-widest text-sm">
              {t('events_view_all', 'Voir tous les événements')}
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
